const routes = [
  {
    path: '/setting/my_account',
    name: 'AccountPage',
    component: () => import('./views/AccountPage.vue'),
    meta: { i18n: ['account-pov', 'staff-pov', 'app-market-pov', 'subscription-pov', 'premium-pov'], pageNameEn: 'My Account' },
  },
  {
    path: '/settings/my_account',
    name: 'AccountPage',
    component: () => import('./views/AccountPage.vue'),
    meta: { i18n: ['account-pov', 'staff-pov', 'app-market-pov', 'subscription-pov', 'premium-pov'], pageNameEn: 'My Account' },
  },
];

export default routes;
